export default __webpack_public_path__ + "25b15a35b9c65d381bcb47f8b8db46f2.svg";